/**
 * Extracts filename from S3 URL
 * @param url - S3 URL string
 * @returns Filename without query parameters
 * @example
 * extractFilenameFromS3Url('https://bucket.s3.amazonaws.com/path/to/file.pdf?token=123')
 * // returns 'file.pdf'
 */
export const extractFilenameFromS3Url = (url: string): string => {
  return url.split('/').pop()?.split('?')[0] || '';
};
